import { Navigate, useOutletContext } from 'react-router-dom';
import type { AppOutletContext } from './utils';
import LoginPage from '@/pages/login';

export const LoginLayoutRoute = () => {
  const { isAuthorized, signIn } = useOutletContext<AppOutletContext>();
  return !isAuthorized ? <LoginPage signIn={signIn} /> : <Navigate to="/" />;
};
